import { ChevronLeft, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSupport } from '../../../../../../../context/support/SupportContext';
import { formatBookingId } from '../../../../../utils/supportHelpers';

const ChatHeader = () => {
  const navigate = useNavigate();
  const { chatThread, activeVoucherInfo, handleBackToChatList } = useSupport();

  if (!chatThread) return null;

  const bookingIdFormatted = formatBookingId(chatThread.booking_id);
  const targetVoucherId =
    activeVoucherInfo?._id ||
    (typeof chatThread.voucher_id === 'object'
      ? chatThread.voucher_id?._id
      : chatThread.voucher_id) ||
    chatThread.booking_id;

  const handleNavigateToVoucher = () => {
    if (targetVoucherId) {
      navigate(`/voucher-dashboard/${targetVoucherId}`);
    }
  };

  return (
    <div className="px-5 py-3.5 border-b border-gray-100 flex items-center justify-between bg-white">
      <div className="flex items-center gap-3">
        <button
          onClick={handleBackToChatList}
          className="md:hidden p-1 -ml-1 text-gray-500 hover:bg-gray-100 rounded-full cursor-pointer"
        >
          <ChevronLeft size={22} />
        </button>

        <div className="w-10 h-10 rounded-full bg-[#067978]/10 text-[#067978] flex items-center justify-center font-bold text-sm">
          {chatThread.guest_name ? chatThread.guest_name.charAt(0).toUpperCase() : 'T'}
        </div>

        <div>
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-gray-900 text-sm tracking-tight">
              {chatThread.guest_name || 'Traveller'}
            </h3>
            <span className="px-2 py-0.5 bg-[#067978]/10 text-[#067978] rounded text-[11px] font-mono font-medium lowercase">
              #{bookingIdFormatted}
            </span>
          </div>
          {activeVoucherInfo?.guest_information?.contact_number && (
            <p className="text-xs text-gray-400 font-normal mt-0.5">
              {activeVoucherInfo.guest_information.contact_number}
            </p>
          )}
        </div>
      </div>

      {/* Quick Booking Actions */}
      <div className="flex items-center gap-2">
        <button
          onClick={handleNavigateToVoucher}
          className="px-3 py-1.5 bg-gray-50 hover:bg-[#067978] hover:text-white text-gray-600 text-xs font-medium rounded-lg border border-gray-200 transition-all flex items-center gap-1.5 cursor-pointer"
        >
          <ExternalLink size={13} />
          <span className="hidden sm:inline">View Voucher</span>
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
